import { render } from "./mahila-mandal.vue?vue&type=template&id=9e8cb124&scoped=true"
import script from "./mahila-mandal.vue?vue&type=script&lang=js"
export * from "./mahila-mandal.vue?vue&type=script&lang=js"

import "./mahila-mandal.vue?vue&type=style&index=0&id=9e8cb124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8cb124"]])

export default __exports__